import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { PageHeader, SwitchRow, TextAreaRow, TextRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.AccountGracePeriod1, LocationVarKey.AccountGracePeriod2];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Grace Period
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountGracePeriod1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountGracePeriod2}
        enableSwitchVar={LocationVarKey.AccountGracePeriod2Enabled}
      />
    </>
  );
}
